export enum DeviceType {
  LED = 'LED',
  LCD = 'LCD',
  SIL = 'SIL',
  VICOM = 'VICOM',
  NVR = 'NVR',
  GPS = 'GPS',
  CAN1 = 'CAN1',
  GPS_FRAME = 'GPS_FRAME',
  TIC = 'TIC',
  CAN2 = 'CAN2',
  BUS_STOP_REPORT = 'BUS_STOP_REPORT',
  CAN3 = 'CAN3',
  CUSTOM_CAN = 'CUSTOM_CAN',
  SEGMENT_TRAVEL_TIME = 'SEGMENT_TRAVEL_TIME',
  AVG_SEGMENT_TRAVEL_TIME = 'AVG_SEGMENT_TRAVEL_TIME',
  GPS_FRAME_HISTORICAL = 'GPS_FRAME_HISTORICAL',
  OBU = 'OBU',
  CAMERA = 'CAMERA',
  STOP_PILE_STAT_DATA_REPORT = 'STOP_PILE_STAT_DATA_REPORT',
  IRMA_REPORT_LOGS = 'IRMA_REPORT_LOGS',
  LINE_PRIORITY = 'LINE_PRIORITY',
  KPPX = 'KPPX',
  ENTRY_COUNTERS = 'ENTRY_COUNTERS',
  TICKET_MACHINE = 'TICKET_MACHINE',
  PLAYLIST_FILE_REPORT = 'PLAYLIST_FILE_REPORT',
  SIL_DATA_UPLOAD_REPORT = 'SIL_DATA_UPLOAD_REPORT'
}

export function getPhysicalDeviceTypes(): DeviceType[] {
  return [DeviceType.LED, DeviceType.LCD, DeviceType.SIL, DeviceType.VICOM, DeviceType.NVR,
  DeviceType.GPS, DeviceType.CAN1, DeviceType.TIC, DeviceType.CAN2, DeviceType.CAN3,
  DeviceType.CUSTOM_CAN, DeviceType.OBU, DeviceType.CAMERA];
}

export function getRemedialStepsDeviceTypes(): DeviceType[] {
  return [DeviceType.LED, DeviceType.LCD, DeviceType.NVR,
  DeviceType.GPS, DeviceType.ENTRY_COUNTERS, DeviceType.TICKET_MACHINE];
}

export function getDeviceTypesForErrorLogReport(): string[] {
  const devicesToReturn = getPhysicalDeviceTypes();
  devicesToReturn.push(DeviceType.IRMA_REPORT_LOGS);
  return devicesToReturn as string[];
}
